import { createAction } from "@reduxjs/toolkit";

export const pressEscapeKey = createAction("keyboard/pressEscapeKey");
